/**
 * UTF-16BE への変換。
 *
 * CTSへ渡すXMLは UTF-16BE(BOM付き) で出力する決まりになっている
 * （docs/16_NewsML出稿仕様書.md）。s3Service と EventDialog の両方で
 * 同じ変換をしていたためここへ集約した。
 */

/**
 * 文字列を UTF-16BE(BOM付き) のバイト列へ変換する。
 * 先頭2バイトは BOM (0xFE 0xFF)。
 */
export const toUtf16BEUint8Array = (str: string): Uint8Array => {
  const buf = new Uint8Array((str.length + 1) * 2);
  // BOM FE FF
  buf[0] = 0xFE; buf[1] = 0xFF;
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    buf[2 + i * 2] = (code >> 8) & 0xFF; // high byte
    buf[3 + i * 2] = code & 0xFF;        // low byte
  }
  return buf;
};
